/**
 * Класс для управления автоматическим показом модальных окон.
 */
export class AutoShowManager {
  private autoShowTimer: ReturnType<typeof setTimeout> | null = null
  private isPaused: boolean = false

  /**
   * Устанавливает таймер для автоматического показа модального окна.
   * @param {string} name - Имя модального окна.
   * @param {number} delay - Задержка перед показом (в миллисекундах).
   * @param {Function} shouldSkipFn - Функция проверки, нужно ли пропустить показ.
   * @param {Function} openModalFn - Функция открытия модального окна.
   */
  public setAutoShow(
    name: string,
    delay: number,
    shouldSkipFn: () => boolean,
    openModalFn: (_name: string) => void
  ): void {
    this.autoShowTimer = setTimeout(() => {
      if (shouldSkipFn() || this.isPaused) {
        if (this.autoShowTimer) {
          clearTimeout(this.autoShowTimer)
        }
        this.setAutoShow(name, delay, shouldSkipFn, openModalFn)
        return
      }

      openModalFn(name)
    }, delay || 0)
  }

  /**
   * Приостанавливает автоматический показ модальных окон.
   */
  public pause(): void {
    if (this.autoShowTimer) {
      this.isPaused = true
    }
  }

  /**
   * Возобновляет автоматический показ модальных окон.
   */
  public resume(): void {
    if (this.isPaused && this.autoShowTimer) {
      this.isPaused = false
    }
  }

  /**
   * Очищает таймер автоматического показа.
   */
  public clear(): void {
    if (this.autoShowTimer) {
      clearTimeout(this.autoShowTimer)
      this.autoShowTimer = null
    }
    this.isPaused = false
  }
}
